import request from '@/utils/request'


// 查询规则列表
export function listRule(query) {
  return request({
    url: '/user/rule/list',
    method: 'get',
    params: query
  })
}

// 查询规则分页
export function pageRule(query) {
  return request({
    url: '/user/rule/page',
    method: 'get',
    params: query
  })
}

// 查询规则分页
export function queryUserByType(query) {
  return request({
    url: '/user/rule/queryUserByType',
    method: 'get',
    params: query
  })
}

// 查询规则列表
export function queryUserByIds(query) {
  return request({
    url: '/user/rule/queryUserByIds',
    method: 'get',
    params: query
  })
}

// 查询规则详细
export function getRule(data) {
  return request({
    url: '/user/rule/detail',
    method: 'get',
    params: data
  })
}

// 新增规则
export function addRule(data) {
  return request({
    url: '/user/rule/add',
    method: 'post',
    data: data
  })
}

// 修改规则
export function updateRule(data) {
  return request({
    url: '/user/rule/edit',
    method: 'post',
    data: data
  })
}

// 删除规则
export function delRule(data) {
  return request({
    url: '/user/rule/delete',
    method: 'post',
    data: data
  })
}
